import { MarkersVisualArgs } from "@progress/kendo-react-charts";
import { drawing } from "@progress/kendo-drawing";

export const academicMarkerVisual = (e: MarkersVisualArgs): drawing.Element => {
    const group = new drawing.Group();
    const center = e.rect.center();
    const color = e.series.color;
    const strokeWidth = e.options.size ? Math.max(2, e.options.size / 12) : 2;

    // left dashed line
    group.append(
        new drawing.Path({
            stroke: { color, width: strokeWidth, dashType: "dash" }
        })
            .moveTo(center.x - 14, center.y)
            .lineTo(center.x - 6, center.y)
    );

    // right dashed line
    group.append(
        new drawing.Path({
            stroke: { color, width: strokeWidth, dashType: "dash" }
        })
            .moveTo(center.x + 6, center.y)
            .lineTo(center.x + 14, center.y)
    );

    // inverted V (A shape)
    group.append(
        new drawing.Path({
            stroke: { color, width: strokeWidth }
        })
            .moveTo(center.x - 6, center.y + 10)
            .lineTo(center.x, center.y - 10)
            .lineTo(center.x + 6, center.y + 10)
    );

    return group;
};